import React, { useContext } from "react";
import { Switch } from "antd";
import FiltersContext from "../../contexts/Filters";
import { settingsAliases } from "../../contexts/User";

function RentalSettingsForm({ kpiSettings, onChange = (key, val) => {} }) {
    const { getFirstFilterValue } = useContext(FiltersContext);
    const ctryid = getFirstFilterValue("filterCountryId");

    return (
        <section id="rentalsettings">
            <form className="space-y-4">
                <div className="flex flex-col">
                    <h3 className="text-xl font-semibold text-indigo-700 my-0">Rental Price Adjustments</h3>
                    <span className="text-sm text-gray-500 opacity-80 font-medium">Flag services used to calculate the adjusted rental measure</span>
                </div>
                <div className="w-2/3 grid grid-cols-3 gap-2">
                    {Object.entries(kpiSettings).map(([key, val]) => {
                        return (
                            key in settingsAliases && (
                                // Enabled &&
                                // Enabled[key] === 1 &&
                                <div key={key} className="w-max flex gap-2 items-center">
                                    <Switch
                                        size="small"
                                        style={{
                                            backgroundColor: val ? "#3a0ca3" : "#EEF1FF",
                                        }}
                                        onChange={(checked) => {
                                            onChange(key, checked ? 1 : 0);
                                        }}
                                        checked={kpiSettings[key] === 1}
                                    />
                                    <label className="text-base" htmlFor={key}>
                                        {settingsAliases[key][ctryid] || settingsAliases[key].default}
                                    </label>
                                </div>
                            )
                        );
                    })}
                </div>
            </form>
        </section>
    );
}

export { RentalSettingsForm };
